import { errorValidation, maskList, geoIpLookup } from './utils';

let lang = document.documentElement.lang || 'en';

let orderClientPhone = $('#order_client_phone');
let orderPaymentPhone = $('#order_payment_phone');
let country_code = $('form[name="order_client"]').data('country_code');

if (orderClientPhone.length || orderPaymentPhone.length) {
	$(window).on('load', function () {
		let phones_exist = false;
		[orderClientPhone, orderPaymentPhone].forEach(phoneInput => {
			var phoneValue = phoneInput.val();
			if (phoneValue) {
				phones_exist = true;
				setTimeout(function () {
					phoneInput.val(phoneValue);
				}, 500);
			}
		});

		if (!phones_exist) {
			setTimeout(function () {
				// geoIpLookup(countryCode => {
				// 	[orderClientPhone, orderPaymentPhone].forEach(phoneInput => {
				// 		phoneInput.intlTelInput('setCountry', countryCode.toLowerCase());
				// 		const maskObj = maskList.find(mask => {
				// 			return (
				// 				mask.cc &&
				// 				typeof mask.cc === 'string' &&
				// 				mask.cc.toLowerCase() === countryCode.toLowerCase()
				// 			);
				// 		});
				// 		if (maskObj) {
				// 			console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// 			phoneInput.inputmask('remove');
				// 			phoneInput.inputmask({ mask: maskObj.mask });
				// 		}
				// 	});
				// });
			}, 500);
		}
	});
}

/**
 * Init intlTelInput
 */
[orderClientPhone, orderPaymentPhone].forEach(phoneInput => {
	phoneInput.intlTelInput({
		initialCountry: 'auto', // Automatically detect the country
		placeholderNumberType: 'aggressive',
		utilsScript:
			'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
		separateDialCode: false,
		allowDropdown: false,
	});

	phoneInput.inputmasks({
		inputmask: {
			definitions: {
				'#': {
					validator: '[0-9]',
					cardinality: 1,
				},
			},
			//clearIncomplete: false,
			showMaskOnHover: false, // Show mask
			autoUnmask: true, // Remove country code when input is empty
		},
		match: /[0-9]/,
		replace: '#',
		list: maskList,
		listKey: 'mask',
		onMaskChange: function (maskObj, completed) {
			if (maskObj) {
				// console.log(`Applying mask for ${maskObj.cc}: ${maskObj.mask}`);
				// let countryCode = Array.isArray(maskObj.cc)
				// 	? maskObj.cc[0].toLowerCase()
				// 	: maskObj.cc.toLowerCase();
				// phoneInput.intlTelInput('setCountry', countryCode);
				phoneInput.intlTelInput('setCountry', country_code.toLowerCase());
			} else {
				console.log(`No mask found, applying default mask`);
				phoneInput.inputmask({ mask: '9999999999' }); // Fallback mask
			}
		},
	});

	// On blur: validate phone number
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateOrderPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Order User
	$("form[name='order_client']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_client[name]': {
				required: true,
			},
			'order_client[surname]': {
				required: true,
			},
			'order_client[birthday]': {
				required: true,
			},
			'order_client[email]': {
				required: true,
				email: true,
			},
			'order_client[phone]': {
				required: true,
				validateOrderPhone: true,
			},
		},
		messages: {
			'order_client[name]': {
				required: window.translations.required,
			},
			'order_client[surname]': {
				required: window.translations.required,
			},
			'order_client[birthday]': {
				required: window.translations.required,
			},
			'order_client[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'order_client[phone]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Order Entity (conditional validation based on active tab)
	if ($("form[name='order_entity']").length) {
		const entityValidation = () => {
			// Determine the active entity tab
			let activeEntityTab = $('.order__entity .order__tab._active').index();
			let rules = {};
			let messages = {};

			if (activeEntityTab === 0) {
				const requiredFields = [
					'company_id',
					'company_name',
					'company_code',
					'bank',
					'iban',
					'region',
					'city',
					'address',
				];
				requiredFields.forEach(field => {
					rules[`order_entity[${field}]`] = { required: true };
					messages[`order_entity[${field}]`] = {
						required: window.translations.required,
					};
				});
			} else if (activeEntityTab === 1) {
				rules['order_entity[cnp]'] = { required: true };
				messages['order_entity[cnp]'] = {
					required: window.translations.required,
				};
			}

			// Apply new validation rules
			const entityForm = $("form[name='order_entity']");
			entityForm.validate().destroy();
			entityForm.validate({
				ignore: [],
				...errorValidation,
				errorClass: 'form__error',
				rules: rules,
				messages: messages,
				submitHandler: form => {
					form.submit();
				},
				success: function (label) {
					let name = label.attr('for');
					label.text('');
				},
			});
		};

		// Initialize entity validation
		entityValidation();

		// Handle entity tab changes
		$('.order__entity .order__tab').on('click', function () {
			setTimeout(() => {
				entityValidation();
			}, 100);
		});
	}

	// Order Payment
	$("form[name='order_payment']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_payment[payment]': {
				required: true,
			},
		},
		messages: {
			'order_payment[payment]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Order Sidebar
	$("form[name='order_sidebar']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'order_sidebar[terms]': {
				required: true,
			},
		},
		messages: {
			'order_sidebar[terms]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();

const deliveryValidation = () => {
	// Determine the active delivery tab (not entity tab)
	let activeDeliveryTab = $('.order__delivery .order__tab._active').index();
	let rules = {};
	let messages = {};

	if (activeDeliveryTab === 0) {
		const fields = ['city', 'region', 'postcode', 'address'];
		fields.forEach(field => {
			rules[`order_delivery[${field}]`] = { required: true };
			messages[`order_delivery[${field}]`] = {
				required: window.translations.required,
			};
		});
	}

	// Apply new validation rules
	const deliveryForm = $("form[name='order_delivery']");
	deliveryForm.validate().destroy();
	deliveryForm.validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: rules,
		messages: messages,
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
};

$('.order__delivery .order__tab').on('click', function () {
	const deliveryType = $(this).data('type');
	const $deliveryTotal = $('.delivery__total');
	const $orderTotal = $('.order__total');
	const totalWithDelivery = $orderTotal.data('with_delivery');
	const totalWithoutDelivery = $orderTotal.data('without_delivery');
	const freeText = $deliveryTotal.data('free');
	const valueText = $deliveryTotal.data('value');
	const currency = $deliveryTotal.data('currency');

	if (deliveryType === 'pickup') {
		$deliveryTotal.text(freeText);
		$orderTotal.find('span').text(totalWithoutDelivery);
	} else {
		if (valueText === freeText) {
			$deliveryTotal.text(freeText);
			$orderTotal.find('span').text(totalWithoutDelivery);
		} else {
			$deliveryTotal.text(valueText + ' ' + currency);
			$orderTotal.find('span').text(totalWithDelivery);
		}
	}

	deliveryValidation();
});

/**
 * Check if all forms are valid
 */
const validateForms = () => {
	deliveryValidation();

	let orderUserValid = $("form[name='order_client']").valid();
	let orderDeliveryValid = $("form[name='order_delivery']").valid();
	let orderPaymentValid = $("form[name='order_payment']").valid();
	let orderSidebarValid = $("form[name='order_sidebar']").valid();

	let orderEntityValid = true;
	if ($("form[name='order_entity']").length) {
		orderEntityValid = $("form[name='order_entity']").valid();
	}

	return (
		orderUserValid &&
		orderDeliveryValid &&
		orderPaymentValid &&
		orderSidebarValid &&
		orderEntityValid
	);
};

/**
 * Gather data from all forms and send via AJAX
 */
$('#create_order').on('click', function (event) {
	event.preventDefault();

	if (validateForms()) {
		let orderClientData = $("form[name='order_client']").serializeArray();
		let orderDeliveryData = $("form[name='order_delivery']").serializeArray();
		let orderPaymentData = $("form[name='order_payment']").serializeArray();
		let orderOptionalData = $("form[name='order_optional']").serializeArray();

		let allData = {};
		$.each(orderClientData, function (index, field) {
			allData[field.name] = field.value;
		});

		// Add entity data if form exists
		if ($("form[name='order_entity']").length) {
			let orderEntityData = $("form[name='order_entity']").serializeArray();
			let activeEntityTab = $('.order__entity .order__tab._active').index();

			if (activeEntityTab === 0) {
				const requiredFields = [
					'order_entity[company_id]',
					'order_entity[company_name]',
					'order_entity[company_code]',
					'order_entity[bank]',
					'order_entity[iban]',
					'order_entity[region]',
					'order_entity[city]',
					'order_entity[address]',
				];
				$.each(orderEntityData, function (index, field) {
					if (requiredFields.includes(field.name)) {
						allData[field.name] = field.value;
					}
				});
				allData['order_entity[entity_type]'] = 1;
			} else if (activeEntityTab === 1) {
				$.each(orderEntityData, function (index, field) {
					if (field.name === 'order_entity[cnp]') {
						allData[field.name] = field.value;
					}
				});
				allData['order_entity[entity_type]'] = 2;
			}
		}

		// Handle delivery data - use specific delivery tab selector
		let activeDeliveryTab = $('.order__delivery .order__tab._active').index();
		if (activeDeliveryTab === 0) {
			// First tab: include delivery address fields
			const requiredFields = [
				'order_delivery[city]',
				'order_delivery[region]',
				'order_delivery[postcode]',
				'order_delivery[address]',
			];
			$.each(orderDeliveryData, function (index, field) {
				if (requiredFields.includes(field.name)) {
					allData[field.name] = field.value;
				}
			});
			allData['order_delivery[delivery_type]'] = 1;
		} else if (activeDeliveryTab === 1) {
			allData['order_delivery[delivery_type]'] = 2;
		}

		$.each(orderPaymentData, function (index, field) {
			allData[field.name] = field.value;
		});

		$.each(orderOptionalData, function (index, field) {
			allData[field.name] = field.value;
		});

		$('.loader_replace').html(main_loader);
		$('.flameSVG').css('width', 'auto');
		$('.flameSVG').css('height', 'auto');
		initializeFireAnimation('.loader_replace');
		console.log('allData: ', allData);

		$.ajax({
			url: '/' + lang + '/ajax/order', // путь к обработчику
			type: 'POST', // метод отправки,
			data: allData,
			success: function (response) {
				let result = JSON.parse(response);
				if (result.status == 'payment' && result.url) {
					// window.open(result.url, '_blank');
					window.location.href = result.url;
				} else if (result.status == 'success') {
					window.location.href =
						'/' + lang + '/success?order_id=' + result.order_id;
				} else {
					location.reload();
				}
			},
			error: function (data) {
				console.log(data); // выводим ошибку в консоль
			},
		});
	}
});
